import { AxiosResponse } from "axios";
import BaseService from "../baseService";
import {
  ICancelScheduleContent,
  IScheduleContent,
} from "./content.schedule.types";

class ContentScheduleService extends BaseService {
  constructor(options: any) {
    super(options);
  }

  /**
   * Schedules a content for a specific date and time.
   *
   * @param payload The schedule content payload.
   * @returns A promise that resolves to the server's response containing a success message.
   */
  async schedule(
    payload: IScheduleContent,
  ): Promise<AxiosResponse<{ message: string }>> {
    return this.request({
      method: "POST",
      url: "/api/v1/content/schedule",
      data: payload,
    });
  }

  /**
   * Cancels a scheduled content.
   *
   * @param payload The cancel schedule content payload.
   * @returns A promise that resolves to the server's response containing a success message.
   */
  async cancelSchedule(
    payload: ICancelScheduleContent,
  ): Promise<AxiosResponse<{ message: string }>> {
    return this.request({
      method: "PATCH",
      url: `/api/v1/content/schedule/${payload.contentId}`,
    });
  }
}

export default ContentScheduleService;
